module.exports = __webpack_public_path__ + "static/media/s_5_bg.d1c181bf.mp4";